<footer class="site-footer">
  <div class="footer-container">
    <div class="child-container">
      <div class="right-content">
        <div class="copyright">
          <p class="footer-p">
            <a style="color: #444" href="https://meethongkongsingles.com/sitemap/">
              Copyright
            </a>
            © {{ currentYear }} Meet Hong Kong Singles, LLC. All Rights Reserved Worldwide.
          </p>
        </div>
      </div>
      <div class="left-content">
        <div class="menu-list">
          <ul class="menu">
            <li class="menu-item">
              <a href="https://meethongkongsingles.com/terms-of-use/"
                >Terms of Use</a
              >
            </li>
            <li class="menu-item">
              <a href="https://meethongkongsingles.com/privacy-policy/"
                >Privacy Policy</a
              >
            </li>
            <li class="menu-item">
              <a href="https://meethongkongsingles.com/cookie-policy/"
                >Cookie Policy</a
              >
            </li>
            <li class="menu-item">
              <a href="https://meethongkongsingles.com/ada-compliance/"
                >ADA Compliance</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</footer>
